import { MuiBox, MuiTypography } from "..";
import {
  MuiChipWithPopoverBase,
  MuiChipWithPopoverBaseProps,
} from "../chipWithPopoverBase/MuiChipWithPopoverBase";

export const MuiChipWithListView: React.FC<MuiChipWithPopoverBaseProps> = (
  props,
) => {
  return (
    <MuiChipWithPopoverBase {...props} minPopoverWidth={376}>
      <MuiBox>
        {props.data.map((item) => (
          <MuiBox className="list-item-view" key={item.value}>
            <MuiBox className="full-width">
              <MuiTypography variant="h3Bold" className="text-color">
                {item.label}
              </MuiTypography>
              <MuiTypography variant="h3" className="text-color">
                {item.value}
              </MuiTypography>
            </MuiBox>
          </MuiBox>
        ))}
      </MuiBox>
    </MuiChipWithPopoverBase>
  );
};
